export class GuestDetails {
  email: string
  name: string
}
